export default __webpack_public_path__ + "static/media/br_cnh_back.1cecbe3d.jpeg";